<template>
  <div>

  </div>
</template>

<script>

export default {

  data() {
    return {
      
    };
  },

  mounted() {
    console.log('sso-mounted');
    var me = this
    if (location.href.indexOf('?jwt=') !== -1) {  //从登录页面跳回
    
      var jwt = location.href.split('?jwt=')[1].split('#/')[0]
      console.log('jwt :>> ', jwt);
      localStorage.setItem('jwt', jwt)
    }
    this.$router.replace({path: '/'})
    
  },
  methods: {
 
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/sso.vue